module.exports = __webpack_public_path__ + "static/media/horizontal.ce63d356.svg";